import { Component, OnInit } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CardComponent } from '../shared/card/card.component';
import { GraphService } from '../_services/graph.service';
import { DepartmentResDto } from '../_dtos/departmentResDto';
import { DepartmentsService } from '../_services/departments.service';
import { AuthService } from '../_services/auth.service';
import { forkJoin, mergeMap, tap } from 'rxjs';
import { OrderFormServerComponent } from '../forms/order-form-server/order-form-server.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-server',
  imports: [MatTabGroup, MatTab, CardComponent, TranslateModule],
  templateUrl: './server.component.html',
  standalone: true,
  styleUrl: './server.component.css',
})
export class ServerComponent implements OnInit {
  private defaultDepartment: string | undefined;
  public department: DepartmentResDto | undefined;
  public category: string | undefined;

  protected readonly OrderFormServerComponent = OrderFormServerComponent;

  constructor(
    public authService: AuthService,
    private graphService: GraphService,
    private departmentsService: DepartmentsService,
  ) {
    this.authService = authService;
  }

  ngOnInit() {
    this.graphService
      .getExtensionAttributes()
      .pipe(
        tap((data) => {
          this.defaultDepartment =
            data.onPremisesExtensionAttributes.extensionAttribute1;

          if (this.defaultDepartment === undefined) {
            throw Error('Error retrieving user attributes from Graph API.');
          }
        }),
        mergeMap((data) => {
          // Create an array of observables to run in parallel
          return forkJoin({
            department: this.departmentsService.getDepartmentObservable(
              this.defaultDepartment!,
            ),
            departments: this.departmentsService.getDepartmentsObservable(),
          });
        }),
      )
      .subscribe({
        next: (results) => {
          this.departmentsService.setDepartment(results.department);
          this.departmentsService.setDepartments(
            results.departments.departments,
          );
        },
      });
  }
}
